"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImagePath = exports.convertToBytes = exports.convertBytesToMaxUnits = exports.clone = exports.capitalize = void 0;
exports.memoize = memoize;
exports.objectToQueryString = objectToQueryString;
exports.replaceSpanishCharacter = exports.replacePlaceholders = void 0;
exports.sendFormPostRequest = sendFormPostRequest;
exports.uniquifyObjectsById = exports.sleep = void 0;
const clone = obj => JSON.parse(JSON.stringify(obj));
exports.clone = clone;
const sleep = duration => new Promise(res => setTimeout(() => res(), duration));
exports.sleep = sleep;
const capitalize = string => {
  var _string$;
  return ((_string$ = string[0]) === null || _string$ === void 0 ? void 0 : _string$.toUpperCase()) + string.slice(1);
};
exports.capitalize = capitalize;
const uniquifyObjectsById = objects => {
  const map = new Map(objects.map(o => [o.id, o]));
  return [...map.values()];
};
exports.uniquifyObjectsById = uniquifyObjectsById;
const convertToBytes = size => {
  const tBFactor = 1024 * 1024 * 1024 * 1024;
  const gBFactor = 1024 * 1024 * 1024;
  const [values, unit] = size.split(' ');
  const splitValues = values.split('/');
  let totalBytes = 0;
  if (unit === 'TB') {
    totalBytes = parseFloat(Math.max(...splitValues)) * tBFactor; // Convert TB to bytes
  } else if (unit === 'GB') {
    totalBytes = parseFloat(Math.max(...splitValues)) * gBFactor; // Convert GB to bytes
  }

  return totalBytes;
};
exports.convertToBytes = convertToBytes;
const convertBytesToMaxUnits = maxBytes => {
  let maxValue;
  if (maxBytes >= 1024 * 1024 * 1024 * 1024) {
    maxValue = (maxBytes / (1024 * 1024 * 1024 * 1024)).toFixed(0) + ' TB';
  } else if (maxBytes >= 1024 * 1024 * 1024) {
    maxValue = (maxBytes / (1024 * 1024 * 1024)).toFixed(0) + ' GB';
  } else {
    maxValue = maxBytes.toFixed(0) + ' B';
  }
  return maxValue;
};
exports.convertBytesToMaxUnits = convertBytesToMaxUnits;
const getImagePath = imagePath => {
  const ingressUrl = window.REACT_APP_GS_INGRESS_URL;
  return ingressUrl && !(imagePath !== null && imagePath !== void 0 && imagePath.startsWith('https://')) ? `https://${ingressUrl}/${imagePath}` : imagePath;
};
exports.getImagePath = getImagePath;
const replacePlaceholders = (template, data) => {
  return template === null || template === void 0 ? void 0 : template.replace(/{{(.*?)}}/g, (match, variable) => {
    return data[variable.trim()] || match;
  });
};
exports.replacePlaceholders = replacePlaceholders;
const replaceSpanishCharacter = text => {
  // Define a regular expression to match Spanish special characters
  const regex = /[áéíóúüñ]/g;
  const str = text.replace('¿', '').replace(/_/g, ' ');
  // Replace the special characters with their corresponding non-special characters
  return str.replace(regex, function (char) {
    const charMap = {
      á: 'a',
      é: 'e',
      í: 'i',
      ó: 'o',
      ú: 'u',
      ü: 'u',
      ñ: 'n'
    };
    return charMap[char];
  });
};
exports.replaceSpanishCharacter = replaceSpanishCharacter;
function sendFormPostRequest(_ref) {
  let {
    url,
    data,
    target = '_blank'
  } = _ref;
  //Hidden Form
  const form = document.createElement('form');
  form.setAttribute('method', 'post');
  form.setAttribute('action', url);
  form.setAttribute('target', target);
  Object.keys(data).forEach(key => {
    const input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('id', `__${key}`);
    input.setAttribute('name', key);
    input.setAttribute('value', data[key]);
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
  form.remove();
}
function objectToQueryString(obj) {
  const params = new URLSearchParams();
  // Iterate over the object's properties and append them to the URLSearchParams
  for (const [key, value] of Object.entries(obj)) {
    if (value) params.append(key, value);
  }
  // Convert the URLSearchParams to a string
  const queryString = params.toString();
  return queryString;
}
function memoize(fn) {
  const cache = {};
  return async function () {
    const args = JSON.stringify(arguments);
    console.log('arguments passed to memoize fn: ', args);
    console.log('cache data: ', cache);
    cache[args] = cache[args] || fn(...arguments);
    return cache[args];
  };
}